<template>
  <div class="shimmer-card-grid">
    <div
      v-for="n in count"
      :key="n"
      class="shimmer-card"
    >
      <div class="shimmer-card__top">
        <span class="shimmer shimmer-card__avatar" />
        <span class="shimmer shimmer-card__dots" />
      </div>
      <span class="shimmer shimmer-card__line shimmer-card__line--title" />
      <span class="shimmer shimmer-card__line shimmer-card__line--badge" />
      <span class="shimmer shimmer-card__line shimmer-card__line--meta" />
      <span class="shimmer shimmer-card__line shimmer-card__line--meta shimmer-card__line--short" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShimmerCardGrid',
  props: {
    count: {
      type: Number,
      default: 8,
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes shimmer-sweep {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}

.shimmer {
  display: block;
  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fb 37%, #eef0f4 63%);
  background-size: 400px 100%;
  animation: shimmer-sweep 1.4s ease-in-out infinite;
  border-radius: 6px;
}

.shimmer-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 1rem;
}

.shimmer-card {
  padding: 1rem;
  border: 1px solid #eeeef4;
  border-radius: 14px;
  background: #fff;
}

.shimmer-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

.shimmer-card__avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
}

.shimmer-card__dots {
  width: 18px;
  height: 18px;
  border-radius: 5px;
}

.shimmer-card__line {
  height: 10px;
  margin-bottom: 0.55rem;

  &--title {
    width: 70%;
    height: 13px;
  }

  &--badge {
    width: 45%;
    height: 18px;
    border-radius: 999px;
  }

  &--meta {
    width: 85%;
  }

  &--short {
    width: 55%;
    margin-bottom: 0;
  }
}

@media (max-width: 767.98px) {
  .shimmer-card-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 0.75rem;
  }
}
</style>
